import { debounce }   from "lodash";
import { useRouter }  from "next/router";
import useSWRInfinite from "swr/infinite";

import { useGetLoggedIn, useGetProfileData }     from "_common/hooks/auth";
import { combineArraysFromObjects, isPageRoute } from "_common/utils";
import { getFanLeaderboard }                     from "_services/api/broadcast";

import Presentation from "./presentation";

const fetchData = async ( { leaderboardData, pageNo } ) => {
	const payload = {
		pageNo,
		pageSize               : 10,
		date                   : leaderboardData.date,
		broadcasterSportsFanId : leaderboardData.broadcasterSportsFanId
	};

	try {
		const response = await getFanLeaderboard ( payload );

		return response;
	} catch ( err ) {
		// do something
	}
};

const component = props => {
	const { leaderboardData, theatreModeToggle, isSessionEnded } = props;

	const { data, error, mutate, size, setSize } = useSWRInfinite (
		index => {
			return { key: "leaderboard", pageNo: index + 1, leaderboardData };
		},
		fetchData,
		{
			revalidateOnFocus   : false,
			revalidateFirstPage : false,
			refreshInterval     : 30000
		}
	);

	const isLoadingInitialData = !data && !error;
	const isDepleted           = data?.[size - 1]?.leaderboard?.length === 0;
	const isLoadingMore        = isLoadingInitialData || ( size > 0 && data && typeof data[size - 1] === "undefined" );
	const __data               = combineArraysFromObjects ( data || [], "leaderboard" );

	const userProfile  = useGetProfileData ();
	const isLoggedIn   = useGetLoggedIn ();
	const router       = useRouter ();
	const isStudioPage = isPageRoute ( { router, page: "studio" } );

	const loadMore = () => setSize ( size + 1 );

	const totalLength = data?.length || [];
	const lastElement = totalLength - 1;

	let currentUser, distributionStatus;

	if ( lastElement > -1 ) {
		currentUser        = data[totalLength - 1]?.currentUser;
		distributionStatus = data[totalLength - 1]?.distributionStatus;
	}

	const refreshAllPages = () => {
		mutate (); // Call mutate without arguments to refresh all pages
	};

	const onRefresh = debounce ( refreshAllPages );

	return (
		<Presentation
			broadcasterName = { leaderboardData.broadcasterName }
			currentUser = { currentUser }
			data = { __data }
			distributionStatus = { distributionStatus }
			giveAwayCoins = { leaderboardData.giveAwayCoins }
			isDepleted = { isDepleted }
			isFetching = { isLoadingMore }
			isSessionEnded = { isSessionEnded }
			loadMore = { loadMore }
			onRefresh = { onRefresh }
			showCurrentUserScroreCard = { isLoggedIn && !isStudioPage }
			theatreModeToggle = { theatreModeToggle }
			userProfile = { userProfile }
		/>
	);
};

export default component;
